import { render, staticRenderFns } from "./ForceOnModal.vue?vue&type=template&id=a1ba4396&"
import script from "./ForceOnModal.vue?vue&type=script&lang=ts&"
export * from "./ForceOnModal.vue?vue&type=script&lang=ts&"
import style0 from "./ForceOnModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports